import angular from 'angular';

module.exports = angular.module('market.routes.properties', [
  require('angular-ui-router')
])
.config(function($stateProvider) {
  $stateProvider.state('properties', {
    parent: 'root',
    url: '/properties',
    template: require('./properties.jade')(),
    resolve: {
      leads: (Lead) => {
        return Lead.query().$promise;
      }
    },
    controllerAs: 'propertiesCtrl',
    controller: class {
      constructor($rootScope, leads) {
        this.session = $rootScope.session;
        this.leads = leads.filter(l => l.state == 'offered');
      }

      propertiesUrl() {
        if (this.env === "production") {
          return `https://www.opendoor.com/properties`;
        } else {
          return `https://demo.simplersell.com/properties`;
        }
      }
    }
  });
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/routes/properties.js
 **/